import React from 'react';
import { ProductReview } from '../types';
import StarRating from './StarRating';

interface ReviewProps {
  review: ProductReview;
  customFields?: Array<{ name: string; key: string }>;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ReviewProps>;

const getFieldValue = (review: ProductReview) =>
  (review.customFields && review.customFields.length > 0 && review.customFields.find((x) => x.title)?.value) || 0;

const Review: Props = ({ className, children, review, customFields, ...props }) => {
  return (
    <div {...props} className={`py-32 ${className ? className : ''}`}>
      <div className="space-y-32 md:grid md:grid-cols-12 md:gap-32 md:space-y-0">
        <div className="col-span-3 space-y-8">
          <StarRating rating={review.score} />

          {customFields &&
            customFields.map(({ key, name }) => (
              <div key={key} className="space-y-4">
                <h5 className="text-h5">{name}</h5>

                <div className="flex">
                  <div className="block h-2 bg-gold-dark" style={{ width: `${(getFieldValue(review) / 5) * 100}%` }} />

                  <div
                    className="block h-2 bg-gray-light"
                    style={{ width: `${(1 - getFieldValue(review) / 5) * 100}%` }}
                  />
                </div>
              </div>
            ))}
        </div>

        <div className="col-span-9">
          <div>
            <h4 className="text-h4"> {review.reviewer} </h4>

            <p>{new Date(review.createdAt).toDateString()}</p>
          </div>

          <p>{review.content}</p>
        </div>
      </div>
    </div>
  );
};

export default Review;
